import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ApiFeedbackService} from '../api-feedback.service';

export interface MockProfileSection {
  name: string;
  route: string;
}

export interface MockProfile {
  id: string;
  name: string;
  /** null = acceso a todos los sistemas */
  allowedSystems: string[] | null;
  /** Mapa de route del sistema → rutas de módulos permitidos. null = todos los módulos */
  allowedModules: Record<string, string[] | null> | null;
  /** Secciones del submenú por sistema y módulo: { 'crm': { 'panel': [...] } }. null = sin secciones personalizadas */
  panelSections: Record<string, Record<string, MockProfileSection[]>> | null;
}

export interface MockUser {
  username: string;
  password: string;
  displayName: string;
  profileId: string;
}

const MOCK_PROFILES: MockProfile[] = [
  {
    id: 'admin',
    name: 'Administrador del sistema',
    allowedSystems: null,
    allowedModules: null,
    panelSections: null
  },
  {
    id: 'titulacion',
    name: 'Titulación',
    allowedSystems: ['crm'],
    allowedModules: {
      crm: ['panel', 'expedientes', 'titulacion']
    },
    panelSections: {
      crm: {
        panel: [
          {name: 'Expedientes', route: 'expedientes'}
        ],
        expedientes: [
          {name: 'Expedientes', route: 'expedientes'},
          {name: 'Clientes', route: 'clientes'},
          {name: 'Gerentes', route: 'gerentes'},
          {name: 'Vendedores', route: 'vendedores'},
          {name: 'Inmobiliarias', route: 'inmobiliarias'}
        ]
      }
    }
  }
];

const MOCK_USERS: MockUser[] = [
  {username: 'administrador', password: '123456', displayName: 'Abraham Marquez', profileId: 'admin'},
  {username: 'titulacion', password: '123456', displayName: 'Imelda', profileId: 'titulacion'}
];

@Injectable({providedIn: 'root'})
export class AuthService {
  private readonly SESSION_KEY = 'mockSession';
  private readonly USER_KEY = 'mockUser';

  constructor(private router: Router, private feedback: ApiFeedbackService) {}

  login(username: string, password: string): void {
    this.feedback.showLoading('Validando credenciales…');

    setTimeout(() => {
      const user = MOCK_USERS.find(
        u => u.username.toLowerCase() === username.toLowerCase() && u.password === password
      );

      if (!user) {
        this.feedback.showError('Usuario o contraseña incorrectos');
        return;
      }

      localStorage.setItem(this.SESSION_KEY, 'active');
      localStorage.setItem(this.USER_KEY, JSON.stringify(user));
      this.feedback.showSuccess('Acceso autorizado');

      const profile = this.getProfile();
      const defaultRoute = profile?.allowedSystems
        ? `/${profile.allowedSystems[0]}/` + (profile.allowedModules?.[profile.allowedSystems[0]]?.[0] ?? '')
        : '/crm/panel';

      setTimeout(() => this.router.navigateByUrl(defaultRoute), 500);
    }, 800);
  }

  logout(): void {
    localStorage.removeItem(this.SESSION_KEY);
    localStorage.removeItem(this.USER_KEY);
    this.router.navigate(['/login']);
  }

  isLogged(): boolean {
    return localStorage.getItem(this.SESSION_KEY) === 'active';
  }

  getCurrentUser(): MockUser | null {
    const raw = localStorage.getItem(this.USER_KEY);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch { return null; }
  }

  getProfile(): MockProfile | null {
    const user = this.getCurrentUser();
    if (!user) return null;
    return MOCK_PROFILES.find(p => p.id === user.profileId) ?? null;
  }
}
